import i18n from '@/i18n'
import { clone } from 'ramda'
import { mapActions} from 'vuex'
import { DialogType } from '@/constants/constants'

export default {
    name: 'ScoringDialogFirstLevelTabComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        },
        viewMode: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario de infracción
        infractionValidForm: false,
        // modelo de datos para el formulario
        infractionModel: {
            name: null,
            reference: {
                min: 0,
                max: null
            },
            immunity: null,
            sligth: {
                range: {
                    min: 0,
                    max: null
                },
                weightedValue: null
            },
            medium: {
                range: {
                    min: null,
                    max: null
                },
                weightedValue: null
            },
            serious: {
                range: {
                    min: null,
                    max: null
                },
                weightedValue: null
            }
        },
        // referencias mínima y máxima (para edición, cuando existen más de una infracción configurada)
        minReference: null,
        maxReference: null,
        // nombre actual
        actualName: null,
        // error para el campo del nombre
        nameError: [],
        // headers para la tabla
        headers: [
            {
                text: i18n.t('scoring.editDialog.name'),
                align: 'left',
                sortable: false,
                value: 'name'
            },
            {
                text: i18n.t('scoring.editDialog.reference'),
                align: 'right',
                sortable: false,
                value: 'reference'
            },
            {
                text: i18n.t('scoring.editDialog.immunity'),
                align: 'right',
                sortable: false,
                value: 'immunity'
            },
            {
                text: i18n.t('scoring.editDialog.range'),
                align: 'right',
                sortable: false,
                value: 'sligthRange',
                class: 'header-sligth'
            },
            {
                text: i18n.t('scoring.editDialog.weightedValue'),
                align: 'right',
                sortable: false,
                value: 'sligthWeightedValue',
                class: 'header-sligth'
            },
            {
                text: i18n.t('scoring.editDialog.range'),
                align: 'right',
                sortable: false,
                value: 'mediumRange',
                class: 'header-medium'
            },
            {
                text: i18n.t('scoring.editDialog.weightedValue'),
                align: 'right',
                sortable: false,
                value: 'mediumWeightedValue',
                class: 'header-medium'
            },
            {
                text: i18n.t('scoring.editDialog.range'),
                align: 'right',
                sortable: false,
                value: 'seriousRange',
                class: 'header-serious'
            },
            {
                text: i18n.t('scoring.editDialog.weightedValue'),
                align: 'right',
                sortable: false,
                value: 'seriousWeightedValue',
                class: 'header-serious'
            }
        ],
        // configura el formulario para edición
        update: false,
        // índice de la infracción que se está editando
        updateIndex: null,
        // para validar cambios en el formulario
        infractionClone: {
            name: null,
            reference: {
                min: 0,
                max: null
            },
            immunity: null,
            sligth: {
                range: {
                    min: 0,
                    max: null
                },
                weightedValue: null
            },
            medium: {
                range: {
                    min: null,
                    max: null
                },
                weightedValue: null
            },
            serious: {
                range: {
                    min: null,
                    max: null
                },
                weightedValue: null
            }
        }
    }),
    computed: {
        /**
         * Datos de la tabla
         */
        tableData () {
            const data = []
            this.model.firstLevel.forEach(element => {
                data.push({
                    name: element.name,
                    reference: `${element.reference.max} Km/h`,
                    immunity: this.$t('scoring.editDialog.minutes', { minutes: element.immunity }),
                    sligthRange: this.$t('scoring.editDialog.upToKmh', { km: element.sligth.range.max }),
                    sligthWeightedValue: element.sligth.weightedValue,
                    mediumRange: this.$t('scoring.editDialog.upToKmh', { km: element.medium.range.max }),
                    mediumWeightedValue: element.medium.weightedValue,
                    seriousRange: this.$t('scoring.editDialog.moreThanKmh', { km: element.serious.range.min }),
                    seriousWeightedValue: element.serious.weightedValue,
                })
            })
            return data
        },
        /**
         * Retorna un boolean referido al estado de guardado del formulario
         */
        notSaved () {
            return this.infractionModel.name !== this.infractionClone.name
                || this.infractionModel.immunity !== this.infractionClone.immunity
                || this.infractionModel.reference.min !== this.infractionClone.reference.min
                || this.infractionModel.reference.max !== this.infractionClone.reference.max
                || this.infractionModel.sligth.range.min !== this.infractionClone.sligth.range.min
                || this.infractionModel.sligth.range.max !== this.infractionClone.sligth.range.max
                || this.infractionModel.sligth.weightedValue !== this.infractionClone.sligth.weightedValue
                || this.infractionModel.medium.range.min !== this.infractionClone.medium.range.min
                || this.infractionModel.medium.range.max !== this.infractionClone.medium.range.max
                || this.infractionModel.medium.weightedValue !== this.infractionClone.medium.weightedValue
                || this.infractionModel.serious.range.min !== this.infractionClone.serious.range.min
                || this.infractionModel.serious.range.max !== this.infractionClone.serious.range.max
                || this.infractionModel.serious.weightedValue !== this.infractionClone.serious.weightedValue
        }
    },
    created () {
    },
    mounted () {
    },
    methods: {
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * Para añadir una infracción a la tabla
         */
        add () {
            // conversion de string a numeros
            this.infractionModel.reference.min = Number(this.infractionModel.reference.min)
            this.infractionModel.reference.max = Number(this.infractionModel.reference.max)
            this.infractionModel.immunity = Number(this.infractionModel.immunity)
            this.infractionModel.sligth.range.min = Number(this.infractionModel.sligth.range.min)
            this.infractionModel.sligth.range.max = Number(this.infractionModel.sligth.range.max)
            this.infractionModel.sligth.weightedValue = Number(this.infractionModel.sligth.weightedValue)
            this.infractionModel.medium.range.min = Number(this.infractionModel.medium.range.min)
            this.infractionModel.medium.range.max = Number(this.infractionModel.medium.range.max)
            this.infractionModel.medium.weightedValue = Number(this.infractionModel.medium.weightedValue)
            this.infractionModel.serious.range.min = Number(this.infractionModel.serious.range.min)
            this.infractionModel.serious.range.max = this.infractionModel.serious.range.max ? Number(this.infractionModel.serious.range.max) : null
            this.infractionModel.serious.weightedValue = Number(this.infractionModel.serious.weightedValue)

            if (this.update) {
                const arrayReference = clone(this.model.firstLevel)
                if (this.updateIndex + 1 <= arrayReference.length - 1) {
                    arrayReference[this.updateIndex + 1].reference.min = this.infractionModel.reference.max
                }
                arrayReference[this.updateIndex] = this.infractionModel
                this.model.firstLevel.cleanAndUpdate(arrayReference)
            } else {
                this.model.firstLevel.push(this.infractionModel)
            }

            this.resetFields()
            this.model.showForm = false
        },
        /**
         * Restablece los campos del formulario
         */
        resetFields () {
            this.infractionModel = {
                name: null,
                reference: {
                    min: (this.model.firstLevel.length - 1 >= 0)
                        ? this.model.firstLevel[this.model.firstLevel.length - 1].reference.max
                        : 0,
                    max: null
                },
                immunity: null,
                sligth: {
                    range: {
                        min: 0,
                        max: null
                    },
                    weightedValue: null
                },
                medium: {
                    range: {
                        min: null,
                        max: null
                    },
                    weightedValue: null
                },
                serious: {
                    range: {
                        min: null,
                        max: null
                    },
                    weightedValue: null
                }
            }
            this.infractionClone = clone(this.infractionModel)

            if (this.$refs.scoringFirstLevelInfractionForm) {
                this.$refs.scoringFirstLevelInfractionForm.resetValidation()
            }

            this.actualName = false
            this.update = false
            this.updateIndex = null
            this.maxReference = null
            this.minReference = null
        },
        /**
         * Cancela agregar una nueva infracción y vuelve a mostrar la tabla
         */
        cancel () {
            if (this.notSaved) {
                this.openDialog({
                    title: this.$t('scoring.notSavedTitle'),
                    text: this.$t('scoring.notSavedText'),
                    type: DialogType.WARNING,
                    overlayOpacity: 0.5,
                    actionButtons: true,
                    yesAction: async () => {
                        this.resetFields()
                        this.model.showForm = false
                    },
                    noAction: () => {}
                })
            } else {
                this.resetFields()
                this.model.showForm = false
            }
        },
        /**
         * Valida nombre de infracción dulicado
         */
        duplicatedScoringNameValidation () {
            if (this.infractionModel.name === this.actualName) return
            if (this.model.firstLevel.find(infraction => infraction.name === this.infractionModel.name)) {
                this.nameError.push(this.$t('scoring.duplicate'))
            } else {
                this.nameError = []
            }
        },
        /**
         * Eliminar infracción
         * @param {*} name 
         */
        deleteInfraction (name) {
            const index = this.model.firstLevel.findIndex(element => element.name === name)
            if ((index + 1) < this.model.firstLevel.length) {
                const previousMaxReference = index - 1 >= 0
                    ? this.model.firstLevel[(index - 1)].reference.max
                    : 0
                this.model.firstLevel[(index + 1)].reference.min = previousMaxReference
            }

            const arrayReference = clone(this.model.firstLevel)
            arrayReference.splice(index, 1)
            this.model.firstLevel.cleanAndUpdate(arrayReference)
        },
        /**
         * Editar infracción
         * @param {*} name 
         */
        edit (name) {
            const index = this.model.firstLevel.findIndex(element => element.name === name)
            this.maxReference = (index + 1) < this.model.firstLevel.length
                ? this.model.firstLevel[(index + 1)].reference.max
                : null
            this.minReference = (index - 1) >= 0
                ? this.model.firstLevel[(index - 1)].reference.max
                : 0

            const data = clone(this.model.firstLevel[index])
            this.infractionClone = clone(this.model.firstLevel[index])
            this.infractionModel.name = data.name
            this.infractionModel.reference.min = data.reference.min
            this.infractionModel.reference.max = data.reference.max
            this.infractionModel.immunity = data.immunity
            this.infractionModel.sligth.range.min = data.sligth.range.min
            this.infractionModel.sligth.range.max = data.sligth.range.max
            this.infractionModel.sligth.weightedValue = data.sligth.weightedValue
            this.infractionModel.medium.range.min = data.medium.range.min
            this.infractionModel.medium.range.max = data.medium.range.max
            this.infractionModel.medium.weightedValue = data.medium.weightedValue
            this.infractionModel.serious.range.min = data.serious.range.min
            this.infractionModel.serious.range.max = data.serious.range.max
            this.infractionModel.serious.weightedValue = data.serious.weightedValue

            this.actualName = data.name
            this.updateIndex = index
            this.update = true
            this.model.showForm = true
        }
    },
    watch: {
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal  && this.$refs.scoringFirstLevelInfractionForm) {
                this.$refs.scoringFirstLevelInfractionForm.resetValidation()
            }
        }
    }
}
